import React from 'react';
import styled from 'libs/styled';
import type { ImageTextModule as ImageTextModuleData } from 'libs/sanity/types/generated';
import ImageTextBlock from 'libs/sanity/content/Blocks/ImageTextBlock';

interface ImageTextModuleProps {
    data?: ImageTextModuleData;
    imageLoading?: 'eager' | 'lazy';
}

const ModuleWrapper = styled('div')`
    margin: var(--module-margin-y) 0;
`;

const ImageTextModule: React.FC<ImageTextModuleProps> = (props) => {
    const { data: moduleData, imageLoading = 'lazy' } = props;
    const blockData = moduleData?.block || moduleData;
    if (!blockData) {
        return null;
    }

    return (
        <ModuleWrapper>
            <ImageTextBlock data={{ ...blockData, layout: 'fullWidth' }} imageLoading={imageLoading} />
        </ModuleWrapper>
    );
};

export default ImageTextModule;
